module.exports = __webpack_public_path__ + "img/20.181056f7.png";